import { sizeToNumber } from '@topcon/tuicl/dist/common/utils';
import { TeContainerSlim, TeIcon, TeText } from '@topcon/tuicl-react';
import styled from 'styled-components';

import IconWrapper from '../IconWrapper';
import { background, border } from '../../providers/theme/theme.index';

interface AgreementAccessRightProps {
  title: string;
  description: string;
  unsetWidth?: boolean;
}

function AgreementAccessRight({ title, description, unsetWidth }: AgreementAccessRightProps) {
  return (
    <AccessRightCard
      column
      gap="s"
      padding="s"
      justifyContent="center"
      alignItems="center"
      width={unsetWidth ? undefined : 180}
    >
      <IconWrapper size={sizeToNumber('xs')} backgroundColor={background.brand.primary}>
        <TeIcon name="check" size="m" color="white" />
      </IconWrapper>
      <TeText weight={700} size="s" alignment="center">
        {title}
      </TeText>
      <DescriptionWrapper weight={400} size="s" alignment="center" color="text.secondary">
        {description}
      </DescriptionWrapper>
    </AccessRightCard>
  );
}

const DescriptionWrapper = styled(TeText)`
  flex: 1 !important;
`;

const AccessRightCard = styled(TeContainerSlim)`
  width: 100%;
  height: 100% !important;
  text-wrap: wrap;
  position: relative;
  &:not(:last-child) {
    &:after {
      content: '';
      height: 100%;
      position: absolute;
      top: 0;
      right: 0;
      width: 1px;
      background-color: ${border.secondary} !important;
    }
  }
`;

export default AgreementAccessRight;
